export default __webpack_public_path__ + "static/media/Blue-Sky-Logo.721fab5d.jpg";